export const medlineSurveyJson = {
    "title": "Medicare Health Outcomes Survey",
    "logoPosition": "right",
    "pages": [
        {
            "name": "Introduction",
            "elements": [{
                "type": "panel",
                "name": "patient-information",
                "title": "This survey asks about you and your health. Answer each question, thinking about yourself. Please take the time to complete this survey. Your answers are very important to us. If you are unable to complete this survey, a family member or “proxy” can fill out the survey about you.",
                "elements": [
                    {
                        "type": "panel",
                        "name": "sub-header",
                        "title": "Be sure to read all the answer choices given before marking a selection.",
                        "elements": [
                            {
                                "type": "radiogroup",
                                "name": "Gender",
                                "choices": [
                                    "Male",
                                    "Female",
                                ],
                                "title": "Are you male or female?",
                                "startWithNewLine": false
                            }
                        ]
                    },

                ]
            }],
        },

        {
            "name": "Personal Details",
            "title": "Personal Details",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "Q1",
                    "title": "In general, would you say your health is:",
                    "choices": [
                        "Excellent",
                        "Very Good",
                        "Good",
                        "Fair",
                        "Poor"
                    ],
                },
            ],
        },

        {
            "name": "Activities",
            "title": " The following items are about activities you might do during a typical day.Does your health now limit you in these activities? If so, how much?",
            "elements": [
                {
                    "type": "radiogroup",
                    "name": "Q2",
                    "title": "a. Moderate activities, such as moving a table, pushing a vacuum cleaner, bowling, or playing golf",
                    "choices": [
                        "Yes, limited a lot",
                        "Yes, limited a little",
                        "No, not limited at all",
                    ],
                },
                {
                    "type": "radiogroup",
                    "name": "Q3",
                    "title": "b. Climbing several flights of stairs",
                    "choices": [
                        "Yes, limited a lot",
                        "Yes, limited a little",
                        "No, not limited at all",
                    ],
                },

            ]
        }

    ],
    // "showTOC": true, //this shows the side panel lists.
    "completeText": "Submit",
    "showPreviewBeforeComplete": "showAllQuestions", //Edit, Preview
    "showQuestionNumbers": false,
    "questionErrorLocation": "bottom",
    "widthMode": "static",
    "width": "1200px"
};